module.exports = __webpack_public_path__ + "static/media/trash_light.d47dd054.svg";